import React, { useState } from 'react';
import { useSelector, shallowEqual } from 'react-redux';
import classNames from 'classnames';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';

import { useFormatMessage } from 'hooks';
import config from 'config';
import paths from 'pages/Router/paths';
import CONSTANTS from 'utils/constants';
import NavLink from '../Link';
// import classes from './Aside.module.scss';

export const SubMenu = ({ label, children }) => {
  const [active, setActive] = useState(false);

  return (
    <li className={classNames({ 'is-active': active })}>
      <a
        exact-active-class="is-active"
        className="has-icon has-dropdown-icon"
        onClick={() => setActive(!active)}
      >
        <span className="icon">
          <i className="mdi mdi-view-list" />
        </span>
        <span className="menu-item-label">{label}</span>
        <div className="dropdown-icon">
          <span className="icon">
            <i
              className={classNames(
                'mdi',
                { 'mdi-minus': active },
                { 'mdi-plus': !active }
              )}
            />
          </span>
        </div>
      </a>
      <ul>{children}</ul>
    </li>
  );
};

SubMenu.propTypes = {
  children: PropTypes.node.isRequired,
  label: PropTypes.string.isRequired,
};

const Aside = ({ handleMobileToggle }) => {
  const { isAuth, isAdmin, isInstaller } = useSelector(
    (state) => ({
      isAuth: state.auth.userData.role > 0,
      isAdmin: CONSTANTS.IS_USER_ROLE_ADMIN[state.auth.userData.role],
      isInstaller: CONSTANTS.IS_USER_ROLE_INSTALLER[state.auth.userData.role],
    }),
    shallowEqual
  );

  const { env, version, date, isProd } = config;
  const envMessage = `env: ${env}`;

  // const usersMessage = useFormatMessage('Aside.users');
  const stationsMessage = useFormatMessage('Aside.stations');
  const stationsMapMessage = useFormatMessage('Aside.stationsMap');
  const usersMessage = useFormatMessage('Aside.users');
  const stationsUsersGroupsMessage = useFormatMessage(
    'Aside.stationsUsersGroups'
  );
  const satellitesMessage = useFormatMessage('Aside.satellites');
  return (
    <aside className="aside is-placed-left is-expanded is-flex is-flex-direction-column">
      <div className="is-flex-grow-1">
        <Link
          to={paths.ROOT}
          className={`aside-tools ${!isProd ? 'has-background-warning ' : ''}`}
        >
          <div className="aside-tools-label">
            <span>
              <b>HD-Rain</b>
              <span className="icon mr-0">
                <i className="mdi mdi-chess-rook" />
              </span>
              Tower
            </span>
          </div>
        </Link>
        <div className="menu is-menu-main">
          <ul className="menu-list">
            {/* <li>
              <NavLink
                to={paths.ROOT}
                className="has-icon"
                onClick={handleMobileToggle}
              >
                <span className="icon">
                  <i className="mdi mdi-home" />
                </span>
                <span className="menu-item-label">
                  {useFormatMessage('Aside.home')}
                </span>
              </NavLink>
            </li> */}
            {isAdmin && (
              <li>
                <NavLink
                  to={paths.USERS}
                  className="has-icon"
                  onClick={handleMobileToggle}
                >
                  <span className="icon">
                    <i className="mdi mdi-account-supervisor" />
                  </span>
                  <span className="menu-item-label">{usersMessage}</span>
                </NavLink>
              </li>
            )}

            {isAuth && (
              <li>
                <NavLink
                  to={paths.STATIONS}
                  className="has-icon"
                  onClick={handleMobileToggle}
                >
                  <span className="icon">
                    <i className="mdi mdi-signal-variant" />
                  </span>
                  <span className="menu-item-label">{stationsMessage}</span>
                </NavLink>
              </li>
            )}
            {isAuth && (
              <li>
                <NavLink
                  to={paths.STATIONS_MAP}
                  className="has-icon"
                  onClick={handleMobileToggle}
                >
                  <span className="icon">
                    <i className="mdi mdi-map" />
                  </span>
                  <span className="menu-item-label">{stationsMapMessage}</span>
                </NavLink>
              </li>
            )}
            {isAdmin && (
              <li>
                <NavLink
                  to={paths.STATIONS_USERS_GROUPS}
                  className="has-icon"
                  onClick={handleMobileToggle}
                >
                  <span className="icon">
                    <i className="mdi mdi-border-all" />
                  </span>
                  <span className="menu-item-label">
                    {stationsUsersGroupsMessage}
                  </span>
                </NavLink>
              </li>
            )}
            {isAdmin && (
              <li>
                <NavLink
                  to={paths.SATELLITES}
                  className="has-icon"
                  onClick={handleMobileToggle}
                >
                  <span className="icon">
                    <i className="mdi mdi-satellite-variant" />
                  </span>
                  <span className="menu-item-label">{satellitesMessage}</span>
                </NavLink>
              </li>
            )}
            {(isAdmin || isInstaller) && (
              <li>
                <NavLink
                  to={paths.RBV3STATIONS}
                  className="has-icon"
                  onClick={handleMobileToggle}
                >
                  <span className="icon">
                    <i className="mdi mdi-numeric-3-box" />
                  </span>
                  <span className="menu-item-label">RainBoxes v3</span>
                </NavLink>
              </li>
            )}
            {/* <SubMenu label={useFormatMessage('Aside.dropdownMenu')}>
            <li>
              <NavLink
                className={classes.submenuLink}
                to={paths.SUBMENU_1}
                onClick={handleMobileToggle}
              >
                <span>{useFormatMessage('Aside.submenu1')}</span>
              </NavLink>
            </li>
            <li>
              <NavLink
                className={classes.submenuLink}
                to={paths.SUBMENU_2}
                onClick={handleMobileToggle}
              >
                <span>{useFormatMessage('Aside.submenu2')}</span>
              </NavLink>
            </li>
          </SubMenu> */}
          </ul>
        </div>
      </div>
      <div
        className={`${!isProd ? 'has-background-warning ' : ''}`}
        title={date}
      >
        <p className="m-2">
          {`v${version}`} <br /> {!isProd && envMessage}
        </p>
      </div>
    </aside>
  );
};

Aside.propTypes = {
  handleMobileToggle: PropTypes.func.isRequired,
};

export default Aside;
